import { useState } from 'react';

export type UseSaveThisSearchModal = ReturnType<typeof useSaveThisSearchModal>;

export const useSaveThisSearchModal = () => {
    const [showAuthModal, setShowAuthModal] = useState(false);
    const [defaultAlertFrequency, setDefaultAlertFrequency] = useState('');
    const [showSaveThisSearchModal, setShowSaveThisSearchModal] =
        useState(false);

    return {
        showAuthModal,
        setShowAuthModal,
        defaultAlertFrequency,
        setDefaultAlertFrequency,
        showSaveThisSearchModal,
        setShowSaveThisSearchModal
    };
};
